import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { BehaviorSubject, Observable, Subject } from "rxjs/Rx";
import { environment } from "src/environments/environment";
import { dropdownData } from "../views/pages/app.interface";
import { CommonInfo } from "./../views/pages/app.config";
import * as _ from "lodash";


@Injectable()
export class GrievanceService {
  public baseUrl = environment.apiBaseUrl;
  public publicUrl = environment.apipublicUrl;
  public indiaId = environment.indiaId;
  send_data = new Subject<any>();

  constructor(private http: HttpClient) { }

  saveGrievance(payload) {
    return this.http.post<any>(this.publicUrl + "/api/grievance/SaveUpdateGrievance", payload)
  }
  updateGrievance(payload) {
    return this.http.post<any>(this.publicUrl + "/api/grievance/UpdateGrievanceStatus", payload)
  }

   saveGrievanceForward(payload) {
    return this.http.post<any>(this.publicUrl + "/api/grievance/ForwardGrievance", payload)
  }

   saveGrievanceSubmit(payload) {
    return this.http.post<any>(this.publicUrl + "/api/grievance/UpdateLaptopGrievanceStatus", payload)
  }


  //  GrievanceExcel(payload: any): Observable<Blob> {
  //   debugger;
  //   const url = `${this.publicUrl}/api/grievance/Excel/${payload.hodId}/${payload.universityId}/${payload.districtId}/${payload.instituteOwnershipId}/${payload.instituteTypeId}/${payload.instituteId}/${payload.grievancecategoryId}/${payload.grievanceTypeId}/${payload.grievanceStatus}/${payload.grievanceRelatedToId}/${payload.grievanceUptoDate}`;
  //   return this.http.post(url, {}, { responseType: 'blob' });
  // }

    GrievanceExcel(payload: any): Observable<Blob> {
    const url = `${this.publicUrl}/api/grievance/Excel`;

    return this.http.post(url, payload, {
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    });
  }

   GrievanceExcellaptopScheme(payload: any): Observable<Blob> {
    const url = `${this.publicUrl}/api/grievance/laptopGrievanceExcel`;

    return this.http.post(url, payload, {
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    });
  }
  //  getGrievanceData(yearId: any, refresh: boolean) {
  //   return this.getAPIData("/api/studentacademicinfo/GetAttendanceConfig/" + yearId, refresh);
  // }
}
